import AccessToken from './AccessToken';
import RefreshToken from './RefreshToken';
import api from '@/api';

export class AuthService {
  static LOCAL_STORAGE_ACCESS_TOKEN_KEY = '3p-auth.access-token';

  static LOCAL_STORAGE_REFRESH_TOKEN_KEY = '3p-auth.refresh-token';

  static LOCAL_STORAGE_USER_ID_KEY = '3p-auth.user-id';

  accessToken;

  async getAccessToken() {
    const accessToken = this.accessToken ? this.accessToken : this._loadAccessToken();
    if (accessToken && !accessToken.isExpired()) {
      this.accessToken = accessToken;
      return accessToken;
    }

    const userId = this._loadUserId();
    const refreshToken = this._loadRefreshToken();
    if (userId && refreshToken && !refreshToken.isExpired()) {
      try {
        const response = await api.user.authenticateWithRefreshToken(refreshToken);
        if (response.data.user && response.data.accessToken && response.data.refreshToken) {
          this.saveTokens(response.data.user.id, response.data.accessToken, response.data.refreshToken);

          return this._loadAccessToken();
        }
      } catch (e) {
        console.error('failed to authenticate with refresh token', e);
      }
    }

    this.reset();

    return undefined;
  }

  saveTokens(userId, accessToken, refreshToken) {
    window.localStorage.setItem(AuthService.LOCAL_STORAGE_USER_ID_KEY, userId);
    window.localStorage.setItem(AuthService.LOCAL_STORAGE_ACCESS_TOKEN_KEY, JSON.stringify(accessToken));
    window.localStorage.setItem(AuthService.LOCAL_STORAGE_REFRESH_TOKEN_KEY, JSON.stringify(refreshToken));
  }

  reset() {
    this.accessToken = undefined;
    window.localStorage.removeItem(AuthService.LOCAL_STORAGE_USER_ID_KEY);
    window.localStorage.removeItem(AuthService.LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    window.localStorage.removeItem(AuthService.LOCAL_STORAGE_REFRESH_TOKEN_KEY);
  }

  _loadUserId() {
    const userId = window.localStorage.getItem(AuthService.LOCAL_STORAGE_USER_ID_KEY);
    if (!userId) {
      return null;
    }

    return Number.parseInt(userId, 10);
  }

  _loadAccessToken() {
    const rawToken = window.localStorage.getItem(AuthService.LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    if (!rawToken) {
      return null;
    }

    return new AccessToken(JSON.parse(rawToken));
  }

  _loadRefreshToken() {
    const rawToken = window.localStorage.getItem(AuthService.LOCAL_STORAGE_REFRESH_TOKEN_KEY);
    if (!rawToken) {
      return null;
    }

    return new RefreshToken(JSON.parse(rawToken));
  }
}

const instance = new AuthService();
export default instance;
